(function() {
  'use strict';

  angular.module('component.files')
    .component('files', {
      templateUrl: 'app/components/files/files.html',
      controller: 'FilesController',
      controllerAs: 'filesCtrl',
      bindings: {
        user: '<'
      }
    });
})();
